import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const processed = useRef(false);

  const check = useCallback(async () => {
    try {
      const res = await fetch(`${API}/auth/me`, { credentials: "include" });
      if (!res.ok) throw new Error();
      setUser(await res.json());
    } catch (_) {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip /me here — AuthCallback exchanges session_id first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) return;
    check();
  }, [check]);

  const logout = useCallback(async () => {
    await fetch(`${API}/auth/logout`, { method: "POST", credentials: "include" }).catch(() => {});
    setUser(false);
  }, []);

  const value = { user, setUser, check, logout, processed };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
